import React, { FC, memo } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { GoToIcon } from '../../../lib/icons/goto-icon'
import useText from '../../hooks/useText'

const SLinkButtonContainer = styled.div`
    margin-top: 0.7em;
    display: flex;
`

const SLink = styled(Link)`
    & {
        color: ${({ theme }) => theme.font.darkestColor};
        text-decoration: underline;
        font-size: 16px;
        line-height: 30px;
        margin-left: 0.5em;
        align-self: end;
    }

    &:hover {
        color: ${({ theme }) => theme.font.successColor};
        cursor: pointer;
    }

    &:active {
        color: ${({ theme }) => theme.font.midDarkColor};
    }
`

type LinkButtonProps = {
    titleCode: string
    href: string
    dataTestId?: string
}

const LinkButton: FC<LinkButtonProps> = ({ titleCode, href, dataTestId }) => {
    const text = useText()
    return (
        <SLinkButtonContainer>
            <GoToIcon style={{ alignSelf: 'center' }} />
            <SLink to={href} target="_blank" data-testid={dataTestId}>
                {text(titleCode)}
            </SLink>
        </SLinkButtonContainer>
    )
}

export default memo(LinkButton)
